import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MESSAGE_TEXT ,BUTTON, CHECKSHEETSETTINGDIALOG, OfficeType, ExcreationSortType} from '@core/constants';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InputType, SortType } from '@core/models/enums';
import { cloneDeep } from 'lodash';
import { DialogTemplate, DropdownOption, ExcreationConfigModel, InputParams, NyuShoDisplayConfigModel, SettingConfigModel } from '@core/models/models';
import { MarqueeSpeedService, SessionStorageService } from '@core/services/common';
import { DeviceLicensesService } from '@core/services/apis';
import { Utils, pickLoggedFields } from '@core/helper';
import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY, SAUCER_LOG_ACTION } from '@core/configs';
import { CheckSheetSettingHelper } from '@core/helper/check-sheet-setting.helper';
import { SaucerLogService } from '@core/services/saucer-logs/saucer-log.service';

@Component({
  selector: 'caremoni-excreation-setting-dialog',
  templateUrl: './excreation-setting-dialog.component.html',
  styleUrls: ['./excreation-setting-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ExcreationSettingDialogComponent implements OnInit {

  @Input() headers: any[] = [];
  @Input() sortConfig: any = null;
  @Input() displayUnits: DropdownOption[] = [];
  @Input() displayGroups: DropdownOption[] = [];
  @Output() onSubmitHandler = new EventEmitter();

  inputParams: InputParams = {
    type: InputType.number,
    validate: false,
    readonly: false,
    disabled: false,
    maxLength: 100,
    borderFill: false,
    tabindex: 20
  };
  timeChangePage: number = 30;
  SortType = SortType;
  BUTTON = BUTTON;
  MESSAGE_TEXT = MESSAGE_TEXT;
  CHECKSHEETSETTINGDIALOG = CHECKSHEETSETTINGDIALOG;
  EXCREATION_SORT_TYPE = ExcreationSortType;
  dialogTemplate: DialogTemplate = new DialogTemplate();
  localStorageKey: string = LOCAL_STORAGE_KEY.settingDialog;
  currentHeaders: any[] = [];
  timeRanges: any[] = [6, 5, 4, 3, 2, 1];
  timeRangeSelected: number = 6;

  sortType: ExcreationSortType = ExcreationSortType.BY_EXCREATION_TIME;
  excreationConfig : ExcreationConfigModel = new ExcreationConfigModel();
  nyuShoDisplayConfig : NyuShoDisplayConfigModel = new NyuShoDisplayConfigModel;
  unitSelected: string[] = []; 
  groupSelected: string[] = [];
  sessionGroupData: DropdownOption[] = [];
  isFlashingMoshiokuri: boolean = false;
  marqueeSpeedOptions: DropdownOption[] = [];
  marqueeSpeedRate: string = '';

  constructor(
    public config: DynamicDialogConfig,
    private sessionStorageService: SessionStorageService,
    private deviceLicensesService: DeviceLicensesService,
    private checkSheetSettingHelper: CheckSheetSettingHelper,
    private marqueeSpeedService: MarqueeSpeedService,
    private saucerLogService: SaucerLogService,
  ) {}

  ngOnInit(): void {
    this.dialogTemplate.header = "設定";
    this.dialogTemplate.isModal = true;
    this.dialogTemplate.style = { width: '500px' };
    this.dialogTemplate.styleClass = 'excreation-setting-dialog';
    this.dialogTemplate.hasBottom = true;
    this.marqueeSpeedOptions = this.marqueeSpeedService.getSpeedOptions();
    this.marqueeSpeedRate = `${this.marqueeSpeedService.getSpeedRate()}`;
    // get data từ local storage
    if(!this.getSettingFromSessionStorage()) {
      this.headers = this.headers?.filter((x:any) => !Utils.isNullOrEmpty(x.displayLbl));
      this.currentHeaders = cloneDeep(this.headers);
    }
    this.saucerLogService.action(
      {},
      {
        action: SAUCER_LOG_ACTION.SETTING.VIEW
      }
    );
  }

  async onSubmit() {
    const localSettings = this.getCurrentOfficeScreenSettings() ?? {};

    this.nyuShoDisplayConfig = {
      ...this.nyuShoDisplayConfig,
      unitSelected: this.unitSelected,
      groupSelected: this.groupSelected
    };

    this.excreationConfig = {
      ...this.excreationConfig,
      sortType: this.sortType,
    };

    const submitData = {
      headers: cloneDeep(this.currentHeaders),
      timeChangePage: this.timeChangePage,
      excreationConfig: this.excreationConfig,
      nyuShoDisplayConfig: this.nyuShoDisplayConfig,
      isFlashingMoshiokuri: localSettings?.isFlashingMoshiokuri ?? true,
      userDashboardSettings: localSettings?.userDashboardSettings ?? null,
      bathingScreenConfig: localSettings?.bathingScreenConfig ?? null
    };

    this.marqueeSpeedService.setSpeedRate(this.marqueeSpeedRate);
    await this.saveScreenConfig(submitData);
    this.onSubmitHandler.emit(submitData);
    this.logSettingUpdate(localSettings, submitData);
    this.logCloseDialog();
  }

  onChangeMarqueeSpeed(speedRate: any) {
    this.marqueeSpeedRate = speedRate;
  }

  onChangeTimeRange(event:any){
    this.timeRangeSelected = event;
  }

  onChangeUnit(event:any){
    this.unitSelected = event;
    this.filterGroupByUnit(event);
    const lstGroupsAfterFilter = this.displayGroups.map((x:any)=>(x?.value));
    if (!lstGroupsAfterFilter.includes(this.groupSelected)) {
      this.groupSelected = [];
    }
  }

  closeModal(){
    this.onSubmitHandler.emit(null);
    this.logCloseDialog();
  }

  // lưu setting vào local Storage
  async saveScreenConfig(data: any) {
    const currentSettings = this.getCurrentOfficeScreenSettings() ?? {};
    this.saveCurrentOfficeScreenSettings({
      ...currentSettings,
      ...data,
    });
  }

  // lấy data setting lưu từ session storage
  async getSettingFromSessionStorage() {
    this.sessionGroupData = this.sessionStorageService.getSessionData(LOCAL_STORAGE_KEY.groupData) || [];
    let settingData = this.getCurrentOfficeScreenSettings();
    // map data setting cho dialog
    if (settingData) {
      this.currentHeaders = cloneDeep(settingData.headers || []);
      this.timeChangePage = settingData.timeChangePage ?? 30;
      this.isFlashingMoshiokuri = settingData.isFlashingMoshiokuri ?? false;
      this.nyuShoDisplayConfig = settingData?.nyuShoDisplayConfig || new NyuShoDisplayConfigModel();
      this.unitSelected = settingData?.nyuShoDisplayConfig?.unitSelected;
      this.groupSelected = settingData?.nyuShoDisplayConfig?.groupSelected;
      this.sortType = settingData?.excreationConfig?.sortType ?? ExcreationSortType.BY_EXCREATION_TIME;

      if (!Array.isArray(this.unitSelected)) {
        if (this.unitSelected) {
          this.unitSelected = [this.unitSelected];
        } else {
          this.unitSelected = [];
        }
      }

      await this.filterGroupByUnit(this.unitSelected);

      if (!Array.isArray(this.groupSelected)) {
        if (this.groupSelected) {
          this.groupSelected = [this.groupSelected];
        } else {
          this.groupSelected = [];
        }
      }

      return true;
    }
    return false;
  }

  private getSelectedOfficeCd(): string | null {
    const officeInfo = sessionStorage.getItem(SESSION_STORAGE_KEY.selectedOfficeIdentity);
    if (!officeInfo) return null;

    try {
      return JSON.parse(officeInfo)?.officeCd ?? null;
    } catch {
      return null;
    }
  }

  private getAllScreenSettings(): Record<string, any> {
    const allSettingsInfo = localStorage.getItem(LOCAL_STORAGE_KEY.settingDialog);
    if (!allSettingsInfo) return {};

    try {
      const parsedSettings = JSON.parse(allSettingsInfo);
      return this.isPlainObject(parsedSettings) ? parsedSettings : {};
    } catch {
      return {};
    }
  }

  private getCurrentOfficeScreenSettings(): any {
    const officeCd = this.getSelectedOfficeCd();
    if (!officeCd) return null;

    const allSettings = this.getAllScreenSettings();
    const officeSettings = allSettings[officeCd];
    return this.isPlainObject(officeSettings) ? officeSettings : null;
  }

  private saveCurrentOfficeScreenSettings(officeSettings: Record<string, any>): void {
    const officeCd = this.getSelectedOfficeCd();
    if (!officeCd) return;

    const allSettings = this.getAllScreenSettings();
    allSettings[officeCd] = officeSettings;

    const allSettingsString = JSON.stringify(allSettings);
    localStorage.setItem(LOCAL_STORAGE_KEY.settingDialog, allSettingsString);
    void this.deviceLicensesService.syncSettingConfig();
    if ((window as any).AndroidBridge?.onWebDialogSave) {
      (window as any).AndroidBridge.onWebDialogSave(allSettingsString);
    }
  }

  private isPlainObject(value: unknown): value is Record<string, any> {
    return !!value && typeof value === 'object' && !Array.isArray(value);
  }

  onChangeSettingTime(timeChange: any) {
    if(!timeChange) return;
    this.timeChangePage = parseFloat(timeChange);
  }

  onFocusOutInput(event: any) {
    if (event.target.value < 10) {
      event.target.value = 10;
      this.onChangeSettingTime(10);
    }
  }

  onInputKeyDown(event: any) {
    if(event.key =='Enter') {
      const target = event.target as HTMLElement;
      // Lấy tất cả phần tử có tabindex
      const focusableElements: any[] = Array.from(document.querySelectorAll('[tabindex]')) as HTMLElement[] || [];
      if(focusableElements.length == 0) return;
      // Lọc ra những phần tử có tabindex lớn hơn phần tử hiện tại
      const nextElement: any = focusableElements
        // Chỉ lấy những phần tử có tabindex lớn hơn hiện tại
        .filter(el => el.tabIndex > target.tabIndex) 
        // Sắp xếp theo tabindex tăng dần và lấy phần tử đầu tiên
        .sort((a, b) => a.tabIndex - b.tabIndex)[0];
      
      // Focus vào phần tử tiếp theo nếu tồn tại
      if (nextElement) {
        nextElement.focus();
        event.preventDefault();
      }
    }
  }

  onRadioClick(type: ExcreationSortType) {
    this.sortType = type;
  }

  // Tính toán số cột dựa trên độ dài của data
  get gridColumns(): string {
    // Cố định 4 hàng, cột tự động
    let numCols = Math.ceil(this.currentHeaders.length / 4);
    return `repeat(${numCols}, 1fr)`;
  }

  onChangeHeaderColumns(data: any) {
    this.currentHeaders?.forEach(hdItem => {
      if(hdItem.title == data.title) hdItem.visible = !hdItem.visible;
    });
  }

  onChangeGroup(event:any){
    this.groupSelected = event
  }

  filterGroupByUnit(unitSelected: any[]) {
    this.displayGroups = this.checkSheetSettingHelper.filterGroupByUnit(unitSelected, this.sessionGroupData);
  }

  // #region Saucer Log
  // Không log 'headers' vì dialog này không có UI đổi cột hiển thị.
  private readonly settingLoggedFields = ['timeChangePage', 'excreationConfig', 'nyuShoDisplayConfig', 'isFlashingMoshiokuri'];

  onSaucerLogChangeTab(event: any) {
    const tabNameByValue: Record<string, string> = {
      '0': this.CHECKSHEETSETTINGDIALOG.DISPLAY_SETTING_NYUSHO,
      '2': this.CHECKSHEETSETTINGDIALOG.SETTING_CONFIG
    };
    this.saucerLogService.action(
      {
        content: JSON.stringify({ tab: tabNameByValue[event] ?? event })
      },
      {
        action: SAUCER_LOG_ACTION.SETTING.CHANGE_TAB
      }
    );
  }

  // chỉ log các field mà dialog này thực sự chỉnh sửa (this.settingLoggedFields),
  // bỏ qua các field pass-through (userDashboardSettings, bathingScreenConfig) không thuộc màn hình này.
  private logSettingUpdate(oldSettingData: any, submitData: any): void {
    this.saucerLogService.action(
      {
        content: JSON.stringify({
          old: pickLoggedFields(oldSettingData, this.settingLoggedFields),
          new: pickLoggedFields(submitData, this.settingLoggedFields)
        })
      },
      {
        action: SAUCER_LOG_ACTION.SETTING.UPDATE
      }
    );
  }

  private logCloseDialog(): void {
    this.saucerLogService.action(
      {},
      {
        action: SAUCER_LOG_ACTION.SETTING.CLOSE_DIALOG
      }
    );
  }
  // #endregion Saucer Log
}
